import { render, staticRenderFns } from "./ContactsEditor.vue?vue&type=template&id=35c1ba47&scoped=true"
import script from "./ContactsEditor.vue?vue&type=script&lang=js"
export * from "./ContactsEditor.vue?vue&type=script&lang=js"
import style0 from "./ContactsEditor.vue?vue&type=style&index=0&id=35c1ba47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1ba47",
  null
  
)

export default component.exports